// A customer's fleet site is internal: an asset on it is on no site, so it is
// shown as Unassigned and its technical name never is. `site` is any
// { name, isFleetSite } -- IoT.API sends isFleetSite on every site it returns
// for a gateway or a device.
export const siteLabel = (site, t) =>
  site?.isFleetSite ? t("fleet.unassigned") : site?.name ?? "";

// The site a data export is named after. On the fleet site it is the fleet of
// its gateways (IoT.API sends fleetName for a gateway on the fleet site only),
// without a "Fleet" prefix; Unassigned when they have none or more than one.
export const exportSiteLabel = (site, gateways, t) => {
  if (!site?.isFleetSite) return siteLabel(site, t);
  const fleetNames = new Set((gateways ?? []).map((gw) => gw?.fleetName).filter(Boolean));
  return fleetNames.size === 1 ? [...fleetNames][0] : siteLabel(site, t);
};

// Where a device's or gateway's back arrow leads. The fleet site has no page of
// its own, so an asset on it goes back to the fleet page, as does one reached
// from there.
export const backToListPath = ({ fleetContext, site } = {}) =>
  fleetContext || site?.isFleetSite ? "/std/fleet" : "/std/dvcs";
